import React, {Component} from "react"
import {TextButton} from "@irati/ui/src/Button"
import theme from "@irati/ui/src/global/theme"
import IconBase from "@irati/ui/src/Icon"
import {Wrapper} from "../styled"

interface Props {
  iconMouseOut: () => void,
  iconMouseOver: () => void,
  onClick: () => void
}

class IconWithRollover extends Component<Props> {
  static defaultProps = {
    onClick: () => {}
  }

  state = {
    hover: false
  }

  handleMouseOver = () => this.setState({hover: true})

  handleMouseOut = () => this.setState({hover: false})

  render() {
    const {hover} = this.state
    const {onClick, iconMouseOver, iconMouseOut, ...props} = this.props

    return (
      <TextButton onClick={onClick}>
        <Wrapper
          {...props}
          onMouseOver={this.handleMouseOver}
          onMouseOut={this.handleMouseOut}>
          <IconBase
            icon={hover ? iconMouseOver : iconMouseOut}
            color={hover ? theme.colors.perkbox.blue : theme.colors.fontColor} />
        </Wrapper>
      </TextButton>
    )
  }
}

export default IconWithRollover
